







































































































import { Component, Vue, Prop, Provide, Watch, Emit, Mixins } from 'vue-property-decorator'
import { NetsTab, Ranger, NoResult } from '@/components'
import PreviewBtn from './PreviewBtn.vue'
import QuestionBox from './QuestionBox.vue'
import { isObjectValueEqual, getUrlParams } from '@/utils/urlUtils'
import LessInfo from '@/components/LessInfo'
import ScrollToTop from './../../index/mixins/scrollToTop'
import QPending from '@/apps/question/components/question-pending'
import SmallBtnSkeleton from '@/components/common/small-btn-skeleton'
// import { sa } from '@/utils/sa'

import {
  questionList,
  addQuestionToCart,
  removeUestionFromCart,
  updateQuestionCart
} from './../model/api'
@Component({
  components: {
    NetsTab,
    Ranger,
    PreviewBtn,
    QuestionBox,
    NoResult,
    LessInfo,
    QPending,
    SmallBtnSkeleton
  }
})
export default class QuestionList extends Mixins(ScrollToTop) {
  @Prop() public isUnion!: string

  public currentTitle = ''
  public data: any = []
  public loading = true
  // pagination-data
  public page = 1
  public total = 0
  public sum = 0
  public perPage = 5
  public sortType = 1 // 1 时间排序 2 综合排序 默认1
  public hasAnalysis = false
  public blackList = ['103']
  private currentSite = this.nets[0] // 初始值
  public isMouted = true
  // computed
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get nets() {
    if (this.userInfo && this.userInfo.is_oto_account) {
      if (/^1\d{2}$/.test(this.subject.value)) {
        return [
          [8, '小学OTO'],
          [1, '17题库']
        ]
      }
      return [[1, '17题库']]
    } else {
      return [[1, '17题库']]
    }
  }
  private get subject() {
    return this.$store.state.subject
  }
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get year() {
    return this.$store.state.question.year
  }
  private get diff() {
    return this.$store.state.question.diff
  }
  private get questionType() {
    return this.$store.state.question.questiontype
  }
  private get region() {
    return this.$store.state.question.region
  }
  private get filters() {
    return {
      year: this.year,
      diff: this.diff,
      questionType: this.questionType,
      region: this.region,
      grade: this.$store.state.question.grade,
      textbookVersion: this.$store.state.question.textbookVersion,
      paperType: this.$store.state.question.paperType
    }
  }
  private get factors() {
    return this.$store.state.question.factors
  }
  private get kps() {
    return this.$store.state.question.kps || []
  }
  private get catalog() {
    return this.$store.state.question.catalog
  }
  private get bookorkps() {
    return this.$store.state.question.bookorkps
  }
  private get singleormulti() {
    return this.$store.state.question.singleormulti
  }
  private get book() {
    return this.$store.state.question.book
  }
  private get paperType() {
    return this.$store.state.question.paperType
  }
  private get diffName() {
    return this.$store.state.question.diffname
  }
  private get provinceName() {
    return this.$store.state.question.provincename
  }
  private get questiontypeName() {
    return this.$store.state.question.questiontypename
  }
  private get showTitle() {
    return this.userInfo ? this.userInfo.is_inner_user : ''
  }
  private get grade() {
    return this.$store.state.question.grade
  }
  private get textbookVersion() {
    return this.$store.state.question.textbookVersion
  }
  private get switchTemplate() {
    if (this.loading) {
      return 'pending'
    } else {
      if (this.data.length > 0) {
        return 1
      } else {
        return 2
      }
    }
  }
  private get moduleName() {
    return this.$route.meta.name
  }

  @Watch('userInfo', { deep: true })
  onUserChange(val, old) {
    if (!val) return
    if (old && val.username === old.username) return

    this.page = 1
    this.loadQuestions(this.page)
  }
  @Watch('book')
  onBookChange(val, old) {
    if (~~this.bookorkps === 2) return
    if (val === old) return
    if (!this.isMouted) {
      this.page = 1
      this.loadQuestions(this.page)
    }
  }
  @Watch('singleormulti')
  onSwitchChange(val, old) {
    if (val === old) return
    this.page = 1
    this.loadQuestions(this.page)
  }
  @Watch('bookorkps')
  onStatusChange(val, old) {
    if (val === old) return
    this.page = 1
    this.loadQuestions(this.page)
  }
  @Watch('subject', { deep: true })
  onSubjectChange(val, old) {
    if (val.value === old.value) return
    this.page = 1
    this.currentTitle = ''
    this.hasAnalysis = false
    this.sortType = 1
  }
  @Watch('factors')
  onFactorsChange(val) {
    if (~~this.bookorkps === 1) return
    this.page = 1
    this.loadQuestions(this.page)
  }
  @Watch('kps')
  onKpsChange(val) {
    if (~~this.bookorkps === 1) return
    this.page = 1
    this.loadQuestions(this.page)
  }
  @Watch('catalog')
  onCataChange(val) {
    this.page = 1
    // console.log(3)
    this.loadQuestions(this.page)
  }
  @Watch('filters', { deep: true })
  onFiltersChange(val) {
    if (!this.isMouted) {
      this.$nextTick(() => {
        this.page = 1
        this.loadQuestions(this.page)
      })
    }
  }
  @Watch('currentTitle')
  onCurrentTitleChange(val) {
    if (val === '') {
      this.page = 1
      this.loadQuestions(this.page)
    }
  }
  @Watch('cartInfo', { deep: true })
  onCartChange(val, old) {
    if (isObjectValueEqual(val, old)) {
      return
    }
    this.onFlagChange(this.cartInfo, this.data)
  }
  // 监听点击知识点交集、 并集
  @Watch('isUnion')
  onIsUnionChange(val) {
    this.page = 1
    this.loadQuestions(this.page)
  }
  // mounted
  public mounted() {
    this.isMouted = false
    this.loadQuestions((this.page = 1))
  }

  public onFilterHasAnalysis(e) {
    this.hasAnalysis = e.target.checked
    this.page = 1
    this.loadQuestions(this.page)
    if (this.hasAnalysis) {
      window['sensors'].track('TIKU_afterFilter_clk', {
        moduleName: this.moduleName,
        filter: '有解析'
      })
    }
  }

  public onTabSelect(val) {
    this.page = 1
    this.loadQuestions(this.page)
  }
  public reset() {
    location.href = '/'
  }
  public judgeCode(data) {}
  /**
   * onSearch
   */
  public onSearch() {
    this.page = 1
    this.loadQuestions(this.page)

    window['sensors'].track('TIKU_search', {
      moduleName: this.moduleName,
      keyword: this.currentTitle || ''
    })
  }
  public openAnalysis(item) {
    item.showAnalysis = !item.showAnalysis

    window['sensors'].track('TIKU_otherFunction_clk', {
      moduleName: this.moduleName,
      functionName: item.showAnalysis ? '显示解析' : '收起解析'
    })
  }
  public onClickRanger(val) {
    this.sortType = val
    this.page = 1
    this.loadQuestions(this.page)
    window['sensors'].track('TIKU_afterFilter_clk', {
      moduleName: this.moduleName,
      filter: val == 1 ? '综合排序' : '时间排序'
    })
  }

  public async chooseAll() {
    if (!this.userInfo || !this.userInfo.nickname) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.moduleName,
      buttonName: '本页全选'
    })
    let arr = [...this.cartInfo.question_ids]
    let temp: any = []
    let params: any = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subject.value
    }
    for (let n of this.data) {
      temp = [...temp, n.id]
    }
    params.question_cart.question_ids = [...new Set([...arr, ...temp])]
    let data: any = await updateQuestionCart(params)
    if (data.success) {
      this.$store.commit('SET_CART', data.data)
    } else {
      this.$message.warning(data.error)
    }
  }
  public onFlagChange(data, data2) {
    let dataCopy = JSON.parse(JSON.stringify(data2))
    for (let n of dataCopy) {
      if (!data) {
        return
      }
      if (data.question_ids.findIndex((item) => (n as any).id === item) > -1) {
        n.inShoppingCart = true
      } else {
        n.inShoppingCart = false
      }
      if (n.showAnalysis) {
        n.showAnalysis = true
      } else {
        n.showAnalysis = false
      }
      if (n.is_collected) {
        n.is_collected = true
      } else {
        n.is_collected = false
      }
    }
    this.data = dataCopy
  }
  public useKps() {
    if (~~this.bookorkps === 2) {
      this.factors &&
      this.factors.checked &&
      this.factors.checked.length > 0 &&
      this.singleormulti === '2'
        ? this.processFactors(this.factors.checked)
        : this.processFactors(this.kps)
    } else {
      return this.catalog || ''
    }
  }
  public async loadQuestions(page: number | string, cata?) {
    if (!(this.subject && this.subject.value)) return
    let params: any = {
      subject_id: this.subject.value,
      page: page,
      keyword: this.currentTitle,
      year: this.year,
      difficulty: ~~this.diff,
      sort_type: ~~this.sortType,
      business_type: ~~this.questionType,
      region_code: this.region,
      book_catalog_id: '',
      grade: this.grade,
      paper_type: this.paperType,
      knowledge_point_ids: [],
      kp_search_type: undefined,
      has_analysis: this.hasAnalysis ? 1 : 0 // 是否解析only
    }

    if (~~this.bookorkps === 2) {
      params.book_catalog_id = ''
      if (~~this.singleormulti === 2) {
        params.knowledge_point_ids = this.processFactors(this.factors.checked)
        params.kp_search_type = ~~this.isUnion || 1
      } else {
        params.knowledge_point_ids = this.processFactors(this.kps)
      }
    } else {
      params.knowledge_point_ids = []
      if (this.catalog && !cata) {
        params.book_catalog_id = this.catalog
      } else {
        params.book_catalog_id = this.book
      }
    }

    if (~~this.bookorkps === 2) {
      // 知识点
      params.book_catalog_id = this.textbookVersion
      params.grade_term = this.grade
    } else {
      // 章节
      params.grade_term = undefined
    }
    try {
      this.loading = true
      let data: any = await questionList(params)
      if (data.success) {
        this.total = data.data.total_count
        this.sum = data.data.page_count * this.perPage
        this.onFlagChange(this.cartInfo, data.data.questions)
      } else {
        this.total = 0
        this.sum = 0
        this.data = []
      }
      let kps =
        params.knowledge_point_ids && params.knowledge_point_ids.length
          ? params.knowledge_point_ids.join(',')
          : ''
    } catch (e) {
      this.total = 0
      this.sum = 0
      this.data = []
    } finally {
      this.loading = false
    }
  }
  /**
   * clearSearchInput
   */
  public clearSearchInput() {
    this.currentTitle = ''
  }
  public onPageChange(val) {
    this.page = val
    this.loadQuestions(val)
    this.scrollTo(0) // 滚动到顶
  }
  public async cartAdd(id: number | string) {
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.moduleName,
      buttonName: '加入组卷'
    })
    let data: any = await addQuestionToCart({
      question_id: id,
      subject_id: this.subject.value
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.data)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public async cartDelete(id: number | string) {
    window['sensors'].track('TIKU_OrganizingPapers_addORremove', {
      proSource: this.moduleName,
      buttonName: '移出组卷'
    })
    let data: any = await removeUestionFromCart({
      question_id: id,
      subject_id: this.subject.value
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.data)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public addToCart(data) {
    if (data.val) {
      this.cartAdd(data.id)
    } else {
      this.cartDelete(data.id)
    }
  }
  public processFactors(val) {
    let temp: any = []
    if (val && val.length) {
      for (let n of val) {
        temp = [...temp, ~~n.split('?')[0]]
      }
    }
    return temp
  }

  // public collectInfo() {}
}
